import { z } from 'zod';
// Price schema that matches the Price interface
export const PriceSchema = z.object({
    regular: z.number(),
    sale: z.number().optional(),
    special: z.number().optional(),
});
// Image schema that matches the Image interface
export const ImageSchema = z.object({
    url: z.string(),
    alt: z.string(),
});
// ProductVariant schema
export const ProductVariantSchema = z.object({
    id: z.string(),
    title: z.string(),
    sku: z.string().optional(),
    price: PriceSchema,
    compareAtPrice: PriceSchema.optional(),
    available: z.boolean(),
    inventoryQuantity: z.number().optional(),
    selectedOptions: z.array(z.object({
        name: z.string(),
        value: z.string(),
    })).optional(),
    image: z.union([ImageSchema, z.string()]).optional(),
});
// ProductMetafield schema
export const ProductMetafieldSchema = z.object({
    namespace: z.string(),
    key: z.string(),
    value: z.string(),
    type: z.string().optional(),
});
// ProductRating schema
export const ProductRatingSchema = z.object({
    average: z.number(),
    count: z.number(),
});
// Product schema that matches the Product interface
export const ProductSchema = z.object({
    id: z.string(),
    title: z.string(),
    handle: z.string(),
    brand: z.string(),
    color: z.string(),
    size: z.array(z.string()),
    price: PriceSchema,
    image: z.union([ImageSchema, z.string()]),
    availability: z.enum(['in_stock', 'out_of_stock']),
    promoMessage: z.string().optional(),
    // New optional fields
    sku: z.string().optional(),
    productType: z.string().optional(),
    vendor: z.string().optional(),
    tags: z.array(z.string()).optional(),
    description: z.string().optional(),
    // Multiple images
    images: z.array(z.union([ImageSchema, z.string()])).optional(),
    // Variants
    variants: z.array(ProductVariantSchema).optional(),
    selectedVariant: ProductVariantSchema.optional(),
    // Enhanced inventory
    inventoryQuantity: z.number().optional(),
    inventoryPolicy: z.enum(['deny', 'continue']).optional(),
    // Ratings
    rating: ProductRatingSchema.optional(),
    // Metafields
    metafields: z.array(ProductMetafieldSchema).optional(),
    // Merchandising
    isPinned: z.boolean().optional(),
    isBoosted: z.boolean().optional(),
    sortPriority: z.number().optional(),
    // Publishing
    publishedAt: z.string().optional(),
    status: z.enum(['active', 'draft', 'archived']).optional(),
    // Catch-all for platform-specific data
    customAttributes: z.record(z.any()).optional(),
});
// Compile-time check to ensure schema matches interface
// If these assertions fail, TypeScript will show an error
(() => {
    // This function is never called, it only exists for type checking
    function typeCheck() {
        let product = {};
        let fromSchema = {};
        // Suppress unused variable warnings
        void product;
        void fromSchema;
    }
    // Suppress unused function warning  
    void typeCheck;
});
